module.exports = __webpack_public_path__ + "img/pic3.b91f2942.png";